import React, { Component } from 'react';
import styles from './Wrapper.scss';

class Wrapper extends Component {
  render() {
    return (
      <div className={styles['l-wrapper']}>
        <div className={styles['c-container']}>{this.props.children}</div>
      </div>
    );
  }
}

export default Wrapper;
